import CSS from 'csstype';
import { ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';

import { Splash } from '../Splash';

type Props = {
  isLoading: boolean;
  children: ReactNode;
  color?: CSS.Property.Color;
};

// Styled component makes sure that anything inside of it looks like it is
// behind a background overlay. This allows us to show loading indication while
// still showing preloading UI.
const LoadingContainerStyled = styled.div<Props>`
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none;

  * {
    pointer-events: auto;
  }

  ::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: ${(props) => (props.isLoading ? props.color : 'transparent')};
  }
`;

/**
 * Overlay for showing current UI behind a translucent background to indicate loading status
 * with center positioned animated loading icon.
 *
 * @param props
 */
export const LoadingOverlay = (props: Props) => {
  const theme = useTheme();

  return (
    <LoadingContainerStyled
      className="loading-overlay"
      isLoading={props.isLoading}
      color={props.color || theme.colors.light70}
    >
      {props.isLoading ? (
        <>
          <Splash wrapperStyle={{ zIndex: 1000 }} />
          {props.children}
        </>
      ) : (
        props.children
      )}
    </LoadingContainerStyled>
  );
};

export type LoadingOverlayProps = Props;
